module.exports = __webpack_public_path__ + "6376ccfb11b19c093d78e0647a0386a0.jpg";